import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../../modules/infra/i18n';
import Modal from './Modal';
import enhance from './ModalContainer';

const StockTakingModal = enhance(Modal);

const StockTakingButton = ({ modalIsOn, modalOn, modalOff, products }) => (
  <div>
    <button
      className="c-btn c-btn--medium"
      onClick={modalOn}
      disabled={modalIsOn}
    >
      {t('products:bulk_inventory.stock_taking_button')}
    </button>
    <StockTakingModal
      display-if={modalIsOn}
      close={modalOff}
      products={products}
    />
  </div>
);

StockTakingButton.propTypes = {
  modalIsOn: PropTypes.bool.isRequired,
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
};

export default StockTakingButton;
